import TextArea from "antd/es/input/TextArea";
import { useCallback, useEffect, useRef } from "react";
import { SetState } from "../../../types/SetState";

export const TextAreaResize = ({
  name,
  placeholder,
  rows,
  onResized,
  value,
  onChange,
  style = {},
  maxLength,
}: {
  name?: string;
  placeholder?: string;
  rows?: number;
  onResized?: (height: number) => void;
  value: string;
  onChange: SetState<string>;
  style?: React.CSSProperties;
  maxLength?: number;
}) => {
  const textarea = useRef<HTMLTextAreaElement | null>(null);
  const observer = useRef<ResizeObserver | null>(null);

  const onResize = useCallback(() => {
    if (textarea.current && onResized) {
      const height = (textarea.current as any)?.resizableTextArea?.textArea
        ?.offsetHeight;
      onResized(height);
    }
  }, [textarea, onResized]);

  const onInput = useCallback(() => {
    if (textarea.current) {
      const input = (textarea.current as any)?.resizableTextArea?.textArea;

      input.style.height = "auto";
      input.style.height = input.scrollHeight + "px";
    }
  }, [textarea]);

  useEffect(() => {
    if (textarea.current && !observer.current) {
      observer.current = new ResizeObserver(onResize);
      observer.current.observe(
        (textarea.current as any).resizableTextArea.textArea
      );

      // IMPORTANT removed unmount handling temporary to fix infinite update loop in prod
      // BUG fix later
      // return () => {
      //   if ((textarea.current as any)?.resizableTextArea?.textArea) {
      //     observer.current?.unobserve(
      //       (textarea.current as any).resizableTextArea.textArea
      //     );
      //     observer.current = null;
      //   }
      // };
    }
  }, [textarea, onResize, observer]);

  useEffect(() => {
    if (textarea.current) {
      const input = (textarea.current as any)?.resizableTextArea?.textArea;

      input.setAttribute(
        "style",
        "height:" + input.scrollHeight + "px;overflow-y:hidden;"
      );

      input.addEventListener("input", onInput, false);

      return () => {
        input?.removeEventListener("input", onInput, false);
      };
    }
  }, [textarea]);

  return (
    <TextArea
      ref={textarea as any}
      {...{ name, placeholder, rows, style, maxLength }}
      value={value}
      onChange={(evt) => onChange(evt.target.value ?? "")}
    />
  );
};
